const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'Newsday',
    SITE_DESCRIPTION:
      'Looking for a new job? Search through local classifieds for local jobs & careers from Long Island, Brooklyn, the Bronx, Queens & Manhattan.',
    OG_IMAGE: '/static/newsday/newsday_logo.png',
    DEFAULT_LOCALE: 'en',
    DEFAULT_REGION: 'eu',
    LOCALES: ['en'],
    SOCIAL_LINKS: {
      facebook: 'https://www.newsday.com/facebook',
      twitter: 'https://www.newsday.com/twitter',
      instagram: 'https://www.instagram.com/newsday',
    },
    SHARING_BUTTONS_ENABLED: [
      'facebook',
      'linkedin',
      'email',
      'twitter',
      'whatsapp',
    ],
    LINKEDIN_OAUTH_FEATURE_ACTIVE: false,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: false,
    GOOGLE_OAUTH_FEATURE_ACTIVE: false,
    GA4_MEASUREMENT_IDS: ['G-0G0SCTBQY2', 'G-04SBN34ERZ'],
    BLOG_FEATURE_ACTIVE: true,
    ASSETS: {
      logo: '/static/newsday/newsday_logo.png',
      faviconsPath: '/static/newsday',
    },
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    PRICE_CONFIG: priceConfig,
    THEME: {
      colors: {
        primary: '#005995',
      },
    },
  },
});
